import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeInvitations = data => {
  const invitation = new schema.Entity('invitations')
  return normalize(data, [invitation])
}

const CurrentInvitationsReducer = combineReducers({
  fetchInvitationsRequest: createRequestReducer('CURRENT_INVITATIONS:FETCH'),
  pagination: createReducer(null, {
    'CURRENT_INVITATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data && response.data.assessment_file_invitations_pagination
  }),
  removeInvitationRequests: createMappedRequestReducer(
    'CURRENT_INVITATIONS:REMOVE'
  ),
  counter: createReducer(null, {
    'CURRENT_INVITATIONS:FETCH_COUNTER_REQUEST_SUCCESS': (
      state,
      { response }
    ) => response.data.account.assessment_file_invitations_counter,
    'CURRENT_INVITATIONS:REMOVE_REQUEST_SUCCESS': (state, { params }) =>
      params.seen ? state : state - 1,
    'CURRENT_INVITATIONS:MARK_AS_SEEN_REQUEST_SUCCESS': state => state - 1,
    'CURRENT_INVITATIONS:MARK_AS_UNSEEN_REQUEST_SUCCESS': state => state + 1
  }),
  invitations: createReducer(null, {
    'CURRENT_INVITATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeInvitations(response.data.assessment_file_invitations),
    'CURRENT_INVITATIONS:REMOVE_REQUEST_SUCCESS': (state, { params }) => {
      const invitations = { ...state.entities.invitations }
      delete invitations[params.id]
      return {
        entities: { invitations },
        result: state.result.filter(id => id !== params.id)
      }
    },
    'CURRENT_INVITATIONS:MARK_AS_SEEN_REQUEST_SUCCESS': (
      state,
      { params }
    ) => ({
      ...state,
      entities: {
        invitations: {
          ...state.entities.invitations,
          [params.id]: {
            ...state.entities.invitations[params.id],
            seen: true
          }
        }
      }
    }),
    'CURRENT_INVITATIONS:MARK_AS_UNSEEN_REQUEST_SUCCESS': (
      state,
      { params }
    ) => ({
      ...state,
      entities: {
        invitations: {
          ...state.entities.invitations,
          [params.id]: {
            ...state.entities.invitations[params.id],
            seen: false
          }
        }
      }
    })
  })
})

export default CurrentInvitationsReducer
